export const formatName = (firstName, lastName) => {
  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  return `${capitalize(firstName)} ${capitalize(lastName)}`;
};
